/**
 * P2P Navigation Links Component
 * Displays navigation links for Projects, Members, History, and Team Documents
 */

import React, { memo } from "react";
import { Link } from "react-router-dom";

interface P2PNavigationLinksProps {
  /** Team ID for navigation links */
  teamId: number | null;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Navigation links component for P2P page
 * Displays links to related team pages
 * 
 * @example
 * ```tsx
 * <P2PNavigationLinks teamId={123} />
 * ```
 */
const P2PNavigationLinks: React.FC<P2PNavigationLinksProps> = memo(({ teamId, className = "" }) => {
  if (!teamId) return null;

  const linkState = { teamId, from: "Path To Performance" } as Record<string, unknown>;
  const baseLinkClass = "no-underline! p1 -medium";

  return (
    <div className={`mobile-margin lg:mt-15! ${className}`}>
       <div className="about-this-team" style={{ color: '#677083' }}> About this team :</div>
      <Link
        to="/home/projects"
        data-analytics-type="link"
        state={linkState}
        className={baseLinkClass}
      >
        Projects
      </Link>
      <Link
        to="/home/members"
        data-analytics-type="link"
        state={linkState}
        className={`${baseLinkClass} pl-6!`}
      >
        Members
      </Link>
      <Link
        to="/home/history"
        data-analytics-type="link"
        state={linkState}
        className={`${baseLinkClass} pl-6!`}
      >
        History
      </Link>
      <Link
        to="/home/team-documents"
        data-analytics-type="link"
        state={linkState}
        className={`${baseLinkClass} pl-6!`}
      >
        Team Documents
      </Link>
    </div>
  );
});

P2PNavigationLinks.displayName = "P2PNavigationLinks";

export default P2PNavigationLinks;
